




























































































//@ts-nocheck
//@ts-ignore
import { Component, Vue } from 'vue-property-decorator';


//@ts-ignore
import poa_gobierno from '@/mixins/axios/poa_gobierno'

//@ts-ignore
//import indicador_mes_frecuencias from '@/mixins/axios/indicador_mes_frecuencias'
//@ts-ignore
import TablePPoa from '@/components/tables/tablev1'
//@ts-ignore
import GobiernoHeader from '@/components/headersSelect/gobierno'


//@ts-ignore
import { email, required } from 'vuelidate/lib/validators';
//@ts-ignore
import Notiflix from "notiflix";
//import {Vuetable,VuetablePagination} from 'vuetable-2'


@Component({
  components: {
   /*
    Vuetable,
    VuetablePagination,*/
    GobiernoHeader,
    TablePPoa
  },
  data() {
    return {
        //idmunicipio,nombre, fecha_alta, 
            // tipo, total_empleados, nombre_titular, correo, abreviacion,
 

        columnasd:[
            
            {
                tag:'select',
                data:'select',
                active:false
            },
        {
                tag:'clave',
                data:'clave',
                active:true
            }, 
            {
                tag:'nombre',
                data:'nombre',
                active:true
            },   
                
                {
                tag:'descripcion',
                data:'descripcion',
                active:true
            }, 
            
             {
                tag:'delete',
                data:'delete',
                active:false
            },
            {
                tag:'edit',
                data:'edit',
                active:false
            },
            ],



//indicador_mes_frecuencias:false,


        id:null as any,

      nombre:'' as any,
  clave:'' as any,  descripcion:'' as any,
         
         
              poa_gobierno:[] as any,
        
              //indicador_mes_frecuencias:[] as any,
            
      
    }
  },
     mixins: [poa_gobierno],
     validations: {
    
           nombre: {
      required,
    },
   
           clave: {
      required,
    },
           descripcion: {
      required,
    },
   
  },





  methods:{
             clearstate(){
this.$store.commit('SETGOBIERNO',null);
this.$store.commit('SETSOCIALES',null);
 this.$router.push('/mun/poas/conac/gobierno')
        },

        select(row){


           //this.secretaria_sel=row;
//this.departamentos=true;
 this.$store.commit('SETGOBIERNO',row);
 this.$router.push('/mun/poas/conac/gobierno/sociales')
//this.getDataDepartamentos();

      
     },
      async eliminar(row){
         
this.$root.$emit('loading', true);
let data= await this.ELIMINAR_POA_GOBIERNO(row).then(response => {

                    if (response != null) {

 this.poa_gobierno=this.poa_gobierno.filter(item => item.id !== row.id);
 
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar eliminar paquete, refresque la pagina");

                    }
 this.$root.$emit('loading', false);
                });
      },

     confirm(row){

let th=this;
Notiflix.Confirm.Show('Alerta de confirmacion','Desea eliminar este elemento?','Aceptar','Cancelar',function(){ 
    
    th.eliminar(row);
    },function(){ 
      
        
    });



      
     },
      limpiar(){
this.id=null;
 
      
                 this.nombre=null;

                 this.clave=null;
         this.descripcion=null;


      },
      addRow(){
          this.limpiar();
 $('#ac_modal_poa_gobierno').modal('show')
      },
seteditar(row){

 this.id=row.id;
 this.nombre=row.nombre;

      this.clave=row.clave; this.descripcion=row.descripcion;    
                            
          
 $('#ac_modal_poa_gobierno').modal('show')
    

},
     async crear(dat){
let data= await this.CREAR_POA_GOBIERNO(dat).then(response => {

                    if (response != null) {
                        //this.plantas = response;
console.log(response)

  this.poa_gobierno.push(response)
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar editar indicador areas, refresque la pagina");

                    }    $("#ac_modal_poa_gobierno").modal("hide");
 this.$root.$emit('loading', false);
                    //loading.close();
                });

      },
     async editar(dat){


let data= await this.EDITAR_POA_GOBIERNO(dat).then(response => {

                    if (response != null) {
                        //this.plantas = response;
console.log(response)
 this.$root.$emit("success", "Finalidad modificada correctamente.");
  this.poa_gobierno=this.poa_gobierno.filter(item => item.id !== dat.id);
 this.poa_gobierno.push(response)
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar crear pmd, refresque la pagina");

                    }
 this.$root.$emit('loading', false);
                    //loading.close();
                });


      }
     ,
     async GuardarData(){



console.log('id:'+this.id)

let dat={
  id:this.id,
 
           nombre:this.nombre, 
             clave:this.clave, 
               descripcion:this.descripcion, 
            idmunicipio:this.$store.state.user.usuario.id_municipio,

}
console.log(dat)
 this.$root.$emit('loading', true);
 if(this.id==null){
     this.crear(dat);
 }else{
       this.editar(dat);
 }

      },
async getData() {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data2={
idmunicipio:this.$store.state.user.usuario.id_municipio
};

let data= await this.GET_POA_GOBIERNO(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.poa_gobierno=response;
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    } 
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
/*},
async getDataMesFrecuencia() {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data={
finalidad:this.gobierno_sel.id,
/*mes:this.gobierno_sel.id,
abreviacion:this.gobierno_sel.id,
num_mes:this.gobierno_sel.id,
idmunicipio:this.$store.state.user.usuario.id_municipio




};*/

/*let data= await this.GET_INDICADOR_MES_FRECUENCIA(data).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        

this.mes=response;
this.abreviacion=response;
this.num_mes=response;
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });*/
}

 
  },
  mounted(){
      this.getData();
      //alert('10')
  }
})
export default class Home extends Vue {}

